import * as Linking from 'expo-linking'

const getParamsFromURL = () => {
  return Linking.getInitialURL()
}

export { getParamsFromURL }
